import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../utils'

export const SIGNIN_REQUEST = 'sherrinford/auth/SIGNIN_REQUEST'
export const SIGNIN_SUCCESS = 'sherrinford/auth/SIGNIN_SUCCESS'
export const SIGNIN_ERROR = 'sherrinford/auth/SIGNIN_ERROR'

export const SIGNUP_REQUEST = 'sherrinford/auth/SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'sherrinford/auth/SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'sherrinford/auth/SIGNUP_ERROR'

export const GET_ME_REQUEST = 'sherrinford/auth/GET_ME_REQUEST'
export const GET_ME_SUCCESS = 'sherrinford/auth/GET_ME_SUCCESS'
export const GET_ME_ERROR = 'sherrinford/auth/GET_ME_ERROR'

export const LOGOUT_REQUEST = 'sherrinford/auth/LOGOUT_REQUEST'
export const LOGOUT_SUCCESS = 'sherrinford/auth/LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'sherrinford/auth/LOGOUT_ERROR'

export const VALIDATE_EMAIL_REQUEST = 'sherrinford/auth/VALIDATE_EMAIL_REQUEST'
export const VALIDATE_EMAIL_SUCCESS = 'sherrinford/auth/VALIDATE_EMAIL_SUCCESS'
export const VALIDATE_EMAIL_ERROR = 'sherrinford/auth/VALIDATE_EMAIL_ERROR'

export const SIGNUP_DATA = 'sherrinford/auth/SIGNUP_DATA'
export const SIGNIN_DATA = 'sherrinford/auth/SIGNIN_DATA'
export const PASSWORD_MATCH = 'sherrinford/auth/PASSWORD_MATCH'
export const ERROR = 'sherrinford/auth/ERROR'
export const ERROR_CLEAN = 'sherrinford/auth/ERROR_CLEAN'

export const USER_BY_ID_REQUEST = 'getcraft/auth/USER_BY_ID_REQUEST'
export const USER_BY_ID_SUCCESS = 'getcraft/auth/USER_BY_ID_SUCCESS'
export const USER_BY_ID_ERROR = 'getcraft/auth/USER_BY_ID_ERROR'

export const SIGNIN_GOOGLE_REQUEST = 'getcraft/auth/SIGNIN_GOOGLE_REQUEST'
export const SIGNIN_GOOGLE_SUCCESS = 'getcraft/auth/SIGNIN_GOOGLE_SUCCESS'
export const SIGNIN_GOOGLE_ERROR = 'getcraft/auth/SIGNIN_GOOGLE_ERROR'

const initialStates = {
  isAuthenticated: false,
  isLoading: false,
  isError: false,
  errorMessage: '',
  isRegistered: false,
  isPasswordMatch: false,
  isTypingPassword: false,
  signupData: {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    retypePassword: '',
    verified: true,
    hasAgreedTnc: true,
  },
  signinData: {
    email: '',
    password: '',
  },
  me: {
    id: '',
    user: {
      id: '',
    },
    profiles: [],
  },
}

export default createReducer(initialStates, {
  [PASSWORD_MATCH]: (state, data) => ({
    ...state,
    isTypingPassword: true,
    isPasswordMatch: data,
  }),

  [GET_ME_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_ME_SUCCESS]: (state, res) => ({
    ...state,
    isAuthenticated: true,
    isLoading: false,
    me: res,
  }),

  [GET_ME_ERROR]: (state, res) => ({
    ...state,
    isAuthenticated: false,
    isLoading: false,
    isError: true,
    errorMessage: res,
  }),

  [SIGNUP_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [SIGNUP_SUCCESS]: (state, res) => {
    const user = res

    return {
      ...state,
      user,
      isLoading: false,
      isRegistered: true,
      isTypingPassword: false,
      isPasswordMatch: true,
    }
  },

  [SIGNUP_ERROR]: (state, res) => ({
    ...state,
    isLoading: false,
    isError: true,
    errorMessage: res.error,
  }),

  [SIGNIN_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [SIGNIN_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    isAuthenticated: true,
  }),

  [SIGNIN_ERROR]: (state, res) => {
    const { error } = res
    return {
      ...state,
      isLoading: false,
      isError: true,
      errorMessage: error,
    }
  },

  [VALIDATE_EMAIL_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [VALIDATE_EMAIL_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [VALIDATE_EMAIL_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [USER_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [USER_BY_ID_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),

  [USER_BY_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [LOGOUT_REQUEST]: state => ({
    ...state,
    isLoading: true,
    isAuthenticated: false,
  }),
  [LOGOUT_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [LOGOUT_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [SIGNIN_DATA]: (state, data) => {
    const { signinData } = data
    return {
      ...state,
      signinData,
    }
  },

  [SIGNUP_DATA]: (state, data) => ({
    ...state,
    signupData: {
      ...state.signupData,
      ...data,
    },
  }),

  [ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
  }),

  [ERROR_CLEAN]: state => ({
    ...state,
    isError: initialStates.isError,
    errorMessage: initialStates.errorMessage,
  }),

  [SIGNIN_GOOGLE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [SIGNIN_GOOGLE_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    isAuthenticated: true,
  }),

  [SIGNIN_GOOGLE_ERROR]: (state, res) => {
    const { data } = res
    const auth2 = window.gapi.auth2.getAuthInstance()
    auth2.signOut().then(auth2.disconnect())
    return {
      ...state,
      isLoading: false,
      isError: true,
      errorMessage: data.message,
    }
  },
})

export const signin = (data, cb) => ({
  type: [
    SIGNIN_REQUEST,
    SIGNIN_SUCCESS,
    SIGNIN_ERROR,
  ],
  shuttle: {
    method: 'POST',
    path: '/auth/signin',
    payloads: data,
  },
  nextAction: (res) => {
    cb(res)
  },
})

export const signup = (data, cb = () => {}) => ({
  type: [
    SIGNUP_REQUEST,
    SIGNUP_SUCCESS,
    SIGNUP_ERROR,
  ],
  shuttle: {
    method: 'POST',
    path: '/auth/signup',
    payloads: data,
  },
  nextAction: (res) => {
    cb(res)
  },
})

export function getValidateEmail(email, cb = () => {}) {
  return {
    type: [
      VALIDATE_EMAIL_REQUEST,
      VALIDATE_EMAIL_SUCCESS,
      VALIDATE_EMAIL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/user/validate',
      payloads: {
        email,
      },
    },
    nextAction: res => cb(res),
  }
}

export const getMe = (token, cb = () => {}) => ({
  type: [
    GET_ME_REQUEST,
    GET_ME_SUCCESS,
    GET_ME_ERROR,
  ],
  shuttle: {
    method: 'GET',
    path: '/auth/me',
    authorization: `${token}`,
  },
  nextAction: (res) => {
    cb(res)
  },
})

export function logout(cb = () => {}) {
  return {
    type: [
      LOGOUT_REQUEST,
      LOGOUT_SUCCESS,
      LOGOUT_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/auth/signout',
    },
    nextAction: (res, err) => cb(res, err),
  }
}

export function getUserById(userId, cb = () => {}) {
  const token = isAuthorized()
  return {
    type: [
      USER_BY_ID_REQUEST,
      USER_BY_ID_SUCCESS,
      USER_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/user/${userId}`,
      authorization: `JWT ${token}`,
    },
    nextAction: (res, err) => cb(res, err),
  }
}

export const setPasswordMatch = data => ({
  type: [PASSWORD_MATCH],
  payload: data,
})

export const setSigninData = data => ({
  type: [SIGNIN_DATA],
  payload: data,
})

export const setSignupData = data => ({
  type: [SIGNUP_DATA],
  payload: data,
})

export const setError = data => ({
  type: [ERROR],
  payload: data,
})

export const setErrorClean = () => ({
  type: [ERROR_CLEAN],
})

export const signinGoogle = (data, cb) => ({
  type: [
    SIGNIN_GOOGLE_REQUEST,
    SIGNIN_GOOGLE_SUCCESS,
    SIGNIN_GOOGLE_ERROR,
  ],
  shuttle: {
    method: 'POST',
    path: '/auth/google',
    payloads: data,
  },
  nextAction: (res, err) => cb(res, err),
})
